import React from 'react';
import { motion } from 'framer-motion';

const LoadingSpinner = ({ size = 40, color = '#008a80' }) => {
  return (
    <motion.div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        border: `4px solid rgba(0, 0, 0, 0.1)`,
        borderTopColor: `#008a80`,
        display: 'inline-block',
      }}
      animate={{ rotate: 360 }}
      transition={{
        duration: 1,
        repeat: Infinity,
        ease: 'linear',
      }}
    />
  );
};

export default LoadingSpinner;
